export class InvalidParameterError extends Error {
	public static readonly nullText = "The parameter should not be null";
	public static readonly invalidTypeText = "The parameter type is invalid";

	constructor(public parameter: string, message: string) {
		super(`${message}:${parameter}`);
		Object.setPrototypeOf(this, InvalidParameterError.prototype);
	}
}